interface InfoTextProps {
  label: string;
  text?: string | null;
  link?: string | null;
}

function InfoText({ label, text = "--", link }: InfoTextProps) {
  return (
    <div className="flex flex-col gap-1">
      <div className="text-cool-gray-500">{label}</div>
      {link ? (
        <a
          href={link}
          className="font-medium text-cyan-600 no-underline hover:underline"
        >
          {text}
        </a>
      ) : (
        <div className="font-medium text-cool-gray-900">{text}</div>
      )}
    </div>
  );
}

export default InfoText;
